import { useCallback, useEffect, useRef, useState } from 'react'
import { getUsage } from '../services/prospectingApi'
import type { ProspectingUsage } from '../types'

/** Owner/Admin prospecting usage for the current credits period. */
export function useProspectingUsage(workspaceId: string) {
  const [usage, setUsage] = useState<ProspectingUsage | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const requestId = useRef(0)

  const load = useCallback(() => {
    const id = ++requestId.current
    setLoading(true)
    setError(null)
    getUsage(workspaceId)
      .then((u) => { if (id === requestId.current) setUsage(u) })
      .catch((err) => { if (id === requestId.current) setError(err instanceof Error ? err.message : 'Failed to load usage') })
      .finally(() => { if (id === requestId.current) setLoading(false) })
  }, [workspaceId])

  useEffect(() => { load() }, [load])

  return { usage, loading, error, reload: load }
}
